module.exports = __webpack_public_path__ + "img/ssyx_40.0d52dc86.jpg";